module.exports = __webpack_public_path__ + "static/media/khilkovsky_2_6.b6c3199e.pdf";